import {filter} from 'rxjs/operators';
import {toWsMsg$, wsMsg$} from '@/ws';
import {wsLogin$, wsLogout$} from '@/user/auth-ws';
import FiatAccountMsg = fa.FiatAccountMsg;

wsLogin$.subscribe(() => toWsMsg$.next({method: 'service.subscribe', params: ['service.unitrade']}));
wsLogout$.subscribe(() => toWsMsg$.next({method: 'service.unsubscribe', params: ['service.unitrade']}));

export const fiatAccountMsg$ = wsMsg$.pipe(filter((o: FiatAccountMsg) => o.msgType === 'unitrade.fiat.balance'));

export const fiatDepositSuccessMsg$ = wsMsg$.pipe(filter((o: FiatAccountMsg) => o.msgType === 'unitrade.fiat.deposit.success.notification'));

fiatAccountMsg$.pipe(filter((o) => o.pushType === 'snapshot')).subscribe((o) => {
  o.payload.forEach((row) => {
    if (row.currency !== 'USD') {
      toWsMsg$.next({method: 'tick.subscribe', params: ['.' + row.currency]});
    }
  });
});
